module.exports = __webpack_public_path__ + "static/media/quiz-mbl.8d96d715.png";